import { createFileRoute } from "@tanstack/react-router";

export { TicketActivityPanel as TicketDrawerActivityPanel } from "@/features/tickets/components/ticket-activity-panel";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/tickets/(ticket)/$ticketId/_drawer/activity",
)({
	/** Tab body is composed by the drawer layout into Figma `Details` (entity=ticket). */
	component: () => null,
});
